import { Component } from '@angular/core';
import { ICONS } from 'src/app/core/constants/icons';
import { ROUTES } from 'src/app/core/constants/routes';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  LOGO = ICONS.LOGO;
  HOME_ROUTE = ROUTES.BETTING_TASKS;
}
